export const DEFAULT_AVATAR_PATH = '/default-avatar.svg';

const isNonEmptyString = (value) => typeof value === 'string' && value.trim().length > 0;

export const isValidAvatarUrl = (value) => {
    if (!isNonEmptyString(value)) return false;
    const trimmed = value.trim();

    return (
        trimmed.startsWith('http://') ||
        trimmed.startsWith('https://') ||
        trimmed.startsWith('data:image/') ||
        trimmed.startsWith('blob:') ||
        trimmed.startsWith('/')
    );
};

export const resolveStoredPhotoUrl = (profile, authUser) => {
    const candidates = [
        profile?.photoURL,
        authUser?.photoURL,
        profile?.avatar,
        profile?.profileImage,
    ];

    const match = candidates.find((candidate) => isValidAvatarUrl(candidate));
    return match ? match.trim() : '';
};

export const resolveAvatarUrl = (profile, authUser, fallback = DEFAULT_AVATAR_PATH) => {
    const resolved = resolveStoredPhotoUrl(profile, authUser);
    return resolved || fallback;
};
